import React, {Component} from "react";
import _ from "lodash";
import {connect} from "react-redux";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import * as Yup from "yup";
import Form from "../../../../../utils/forms/components/Form";

import {GamesActionCreators} from "../../../actions/actionCreators";
import {gamesStoreSelectors} from "../../../store/store";
import {ActionCreator} from "../../../../../actions/actions";
import {Subsidiary} from "../../../../../types/types";
import {FormGridField} from "../../../../../utils/forms/components/FormGrid";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";

import {CreationModes} from "../../../reducers/creationMode.reducer";
import {GameEngineVersion} from "../../../reducers/gameEngines.reducer";

import {schemaBasedBox} from "./CreateConfiguration.form";
import {checkDefaultForType} from "../../../../../utils/utils";

import "./CreateConfiguration.component.scss";
import {Denominations} from "../../../reducers/denominations.reducer";
import {subsidiaryDenominations} from "../../../../../utils/addressUtils";

export interface CreateConfProps {
    creatingConf: {
        values: any;
        isValid: boolean;
    };
    creationMode: any;
    updateCreatingConf: ActionCreator;
    editConf: any;
    createConf: any;
    gameEnginesLoading: boolean;
    gameEngines: GameEngineVersion[];
    enginesSchemasLoading: boolean;
    enginesSchemas: any;
    subsidiaries: Subsidiary[];
    subsidiariesLoading: boolean;
    denominations: Denominations[];
    denominationsLoading: boolean;
    gameInfo: any;
}

export interface CreateConfState {
    txtErrorForm: string;
}

const labelFormFields: FormGridField[] = [
    {
        name: "label",
        fieldType: "input",
        fieldOptions: {
            id: "label",
            placeholder: "Name",
            label: "Name",
            inputType: "text"
        },
        validation: Yup.string()
            .max(50, "Max. 50 characters.")
            .required("Name is required."),
        columnClass: "col-12"
    }
];

class CreateConfiguration extends Component<CreateConfProps, CreateConfState> {
    versionSelect: React.RefObject<Components.SelectMenu>;
    subsidiarySelect: React.RefObject<Components.SelectMenu>;
    form: React.RefObject<Form>;

    formsStatus: {
        key: string;
        isValid: boolean;
    }[];

    changeSub: boolean;

    constructor(props) {

        super(props);

        this.formsStatus = [];
        this.form = React.createRef();
        this.versionSelect = React.createRef();
        this.subsidiarySelect = React.createRef();
        this.changeSub = false;

        this.state = {
            txtErrorForm: ""
        };
    }

    onCreate = () => {
        let game = {...this.props.creatingConf.values};
        if(this.props.gameInfo && this.props.gameInfo.type == 0) {
            game["default_coin"]["coin"] = game.default_coin && game.default_coin.coin.length > 0 ? game.default_coin.coin.toString() : null
        }
        game.file = game.image_base64;
        delete game.image_base64;
        delete game.image;
        this.props.createConf(game);
    };

    onEdit = () => {
        let game = {...this.props.creatingConf.values};
        if(this.props.gameInfo && this.props.gameInfo.type == 0) {
            game["default_coin"]["coin"] = game.default_coin && game.default_coin.coin.length > 0 ? game.default_coin.coin.toString() : null
        }
        if (game.image_base64 !== "previous") {
            game.file = game.image_base64;
        }
        delete game.image_base64;
        delete game.image;
        this.props.editConf(game);
    };

    checkSubFormsValidity = () => {
        let isValid = this.formsStatus.length > 0;
        for (let i = 0; i < this.formsStatus.length; i++) {
            if (!this.formsStatus[i].isValid) {
                isValid = false;
            }
        }

        return isValid;
    };

    formChange = (e, key) => {
        // e
        // isValid: false
        // values: {stop: 30, maximum: 90, extra_num: 10, extra_limit: 10}
        // key balls

        let txtErrorForm = "";
        const newValues = {...e.values};
        let values = {...this.props.creatingConf.values};
        values[key] = newValues;

        const formIndex = _.findIndex(this.formsStatus, {key: key});
        if (formIndex > -1) {
            if (key === "balls") {
                this.formsStatus[formIndex].isValid = newValues.extra_limit != "" && newValues.extra_limit != null;
                if (newValues.initial_draw_size || newValues.ball_draw_universe_size) {
                    if (!newValues.initial_draw_size || !newValues.ball_draw_universe_size || newValues.initial_draw_size > newValues.ball_draw_universe_size) {
                        this.formsStatus[formIndex].isValid = false;
                    }
                }
            } else if (key === "cards") {
                this.formsStatus[formIndex].isValid = true;
            } else this.formsStatus[formIndex].isValid = e.isValid;
        }
        if (values.balls && !(values.balls.extra_limit != "" && values.balls.extra_limit != null)) txtErrorForm = "'Balls > Extra Limit': Field is required.";
        if (values.balls && (values.balls.initial_draw_size || values.balls.ball_draw_universe_size)) {
            if (!values.balls.initial_draw_size || !values.balls.ball_draw_universe_size || values.balls.initial_draw_size > values.balls.ball_draw_universe_size) {
                txtErrorForm = "'Balls > Ball Draw Universe Size' must be greater than or equal to 'Balls > Initial Draw Size'";
            }
        }
        this.setState({
            txtErrorForm: txtErrorForm
        });

        this.props.updateCreatingConf(values, this.checkSubFormsValidity());
    };

    labelFormChange = e => {
        let values = {};
        if (
            this.props.creatingConf &&
            this.props.creatingConf.values &&
            Object.keys(this.props.creatingConf.values).length > 0
        ) {
            values = {...this.props.creatingConf.values};
        }

        values["label"] = e.values["label"];
        const formIndex = _.findIndex(this.formsStatus, {key: "label"});
        if (formIndex > -1) {
            this.formsStatus[formIndex].isValid = e.isValid;
        } else {
            this.formsStatus.push({
                key: "label",
                isValid:
                    values["label"] == undefined ||
                    values["label"] == null ||
                    values["label"].length >= 50
                        ? false
                        : true
            });
        }

        this.props.updateCreatingConf(values, this.checkSubFormsValidity());
    };

    /*onVersionChange = e => {
        let values = {};
        if (
            this.props.creatingConf &&
            this.props.creatingConf.values &&
            Object.keys(this.props.creatingConf.values).length > 0
        ) {
            values = { ...this.props.creatingConf.values };
        }

        values["engine"] = e;
        this.formsStatus = [
            {
                key: "version",
                isValid: true
            }
        ];

        this.props.updateCreatingConf(values, this.checkSubFormsValidity());
    };*/

    onSubsidiaryChange = e => {
        let values = {};
        if (
            this.props.creatingConf &&
            this.props.creatingConf.values &&
            Object.keys(this.props.creatingConf.values).length > 0
        ) {
            values = {...this.props.creatingConf.values};
        }

        values["subsidiary"] = e;
        const formIndex = _.findIndex(this.formsStatus, {
            key: "subsidiary"
        });
        if (formIndex > -1) {
            this.formsStatus[formIndex].isValid = true;
        } else {
            this.formsStatus.push({
                key: "subsidiary",
                isValid: true
            });
        }

        let obj = this.formsStatus.find(o => o.key === 'active_coins');
        if (obj) {
            values["active_coins"]["coins"] = []
            obj['isValid'] = false
        }

        obj = this.formsStatus.find(o => o.key === 'default_coin');
        if (obj) {
            values["default_coin"]["coin"] = []
            obj['isValid'] = false
        }

        this.props.updateCreatingConf(values, this.checkSubFormsValidity());
        this.changeSub = true;
    };

    componentDidUpdate(prevProps) {
        if (prevProps.creationMode !== this.props.creationMode) {
            this.formsStatus = [];
        }

        //let engine = "Choose a Version...";
        let subsidiary = "Choose Subsidiary...";
        if (prevProps.creatingConf && this.props.creatingConf) {
            /*if (
                prevProps.creatingConf.values.engine !==
                this.props.creatingConf.values.engine
            ) {
                const engineIndex = _.findIndex(this.props.gameEngines, {
                    id: this.props.creatingConf.values.engine
                });
                if (engineIndex > -1) {
                    engine = this.props.gameEngines[engineIndex].version;
                }

                this.versionSelect.current.setDisplayString(engine);
            }

            if (this.props.creatingConf.values.engine == undefined) {
                this.versionSelect.current.setDisplayString(engine);
            }*/

            if (
                prevProps.creatingConf.values.subsidiary !==
                this.props.creatingConf.values.subsidiary &&
                prevProps.creatingConf.values.id !==
                this.props.creatingConf.values.id &&
                this.props.creatingConf.values.subsidiary !== undefined
            ) {
                const subsidiaryIndex = _.findIndex(this.props.subsidiaries, {
                    id: this.props.creatingConf.values.subsidiary
                });

                if (subsidiaryIndex > -1) {
                    const subsidiary = this.props.subsidiaries[subsidiaryIndex];
                    this.subsidiarySelect.current.setDisplayString(
                        <div
                            key={`${subsidiaryIndex}-${subsidiary.id}`}
                            className="select-country"
                        >
                            {SubsidiaryUtils.subsidiaryIcon(subsidiary)}
                            <span>{subsidiary.description}</span>
                        </div>
                    );
                }
            }

            if (
                this.props.creatingConf.values.subsidiary == undefined &&
                this.subsidiarySelect.current
            ) {
                if (_.findIndex(this.formsStatus, {key: "subsidiary"}) < 0) {
                    this.formsStatus = [
                        {
                            key: "subsidiary",
                            isValid: false
                        }
                    ];
                }
                this.subsidiarySelect.current.setDisplayString(subsidiary);
            }
        } else if (!this.props.creatingConf) {
            //this.versionSelect.current.setDisplayString(engine);
        }
    }

    getSchemaForSelectedVersion = () => {
        /*const engineIndex = _.findIndex(this.props.gameEngines, {
            id: version
        });

        if (engineIndex > -1) {
            return this.props.gameEngines[engineIndex].engine.schema;
        }*/

        if (this.props.gameEngines.length > 0) {
            return this.props.gameEngines.find(engine => engine.id == 1)['game_engine'].schema;
        }

        return undefined;
    };

    renderSchemaForm = () => {
        let getSchema = this.getSchemaForSelectedVersion();
        let schemaProperties = {};

        if (this.props.gameInfo && this.props.gameInfo.type == 0) {
            schemaProperties["active_coins"] = getSchema['properties']["active_coins"]
            schemaProperties["default_coin"] = getSchema['properties']["default_coin"]
        }
        schemaProperties["rtp_settings"] = getSchema['properties']["rtp_settings"]
        schemaProperties["cards"] = getSchema['properties']["cards"]
        schemaProperties["balls"] = getSchema['properties']["balls"]
        getSchema.required.map(field => {
            schemaProperties[field] = getSchema['properties'][field]
        });
        const schema = {
            ...getSchema,
            properties: schemaProperties
        }
        //this.props.creatingConf.values.engine
        //);

        const current_denominations = this.props.denominations.find(d => d['subsidiary'].includes(this.props.creatingConf.values.subsidiary))
        let print_denominations = []
        current_denominations && "denominations" in current_denominations && current_denominations.denominations.map(d => print_denominations.push({
            label: subsidiaryDenominations[current_denominations["country_id"]]((d / 100).toString()),
            value: d
        }))
        let upd = 0
        return Object.keys(schema.properties).map(key => {

            const property = schema.properties[key];

            if (property) property['denominations'] = print_denominations
            if (print_denominations.length > 0 && property && property.hasOwnProperty("properties")) {
                const form = schemaBasedBox({
                    schema: property,
                    required: getSchema.required
                });

                let defaults = {};
                if (this.props.creatingConf.values.hasOwnProperty(key)) {
                    defaults = this.props.creatingConf.values[key];
                } else {
                    Object.keys(property.properties).map(defaultKey => {
                        if (
                            property.properties[defaultKey].hasOwnProperty(
                                "default"
                            )
                        ) {
                            defaults[defaultKey] = property.properties[
                                defaultKey
                                ].hasOwnProperty("convert")
                                ? property.properties[defaultKey]["default"] /
                                100
                                : property.properties[defaultKey]["default"];
                        } else {
                            defaults[defaultKey] = checkDefaultForType(
                                property.properties[defaultKey]["type"],
                                property.properties[defaultKey].hasOwnProperty(
                                    "enum"
                                )
                                    ? property.properties[defaultKey]["enum"]
                                    : undefined
                            );
                        }
                    });
                }

                const formStatusIndex = _.findIndex(this.formsStatus, {
                    key: key
                });

                if (formStatusIndex == -1) {
                    this.formsStatus.push({
                        isValid: false,
                        key
                    });
                }
                if (this.changeSub) {
                    if (key == 'default_coin') defaults = {coin: []}
                    if (key == 'active_coins') defaults = {coins: []}
                    upd++
                    this.changeSub = false

                }

                return (
                    <React.Fragment
                        key={`${this.props.creatingConf.values.id}-${form.title}-${upd}`}
                    >
                        <div className="col-12">
                            <div className="inner-card-title">{form.title}</div>
                        </div>
                        <Form
                            fields={form.fields}
                            onChange={e => this.formChange(e, key)}
                            initialValues={defaults}
                        />
                    </React.Fragment>
                );
            }
        });
    };

    render() {
        if (this.props.gameEnginesLoading && this.props.enginesSchemasLoading) {
            return (
                <div id="create-game">
                    <div className="create-content">
                        <div className="loading-container">
                            <Components.LoadingRipple
                                width={"100px"}
                                height={"100px"}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div id="create-configuration">
                <div className="create-content">
                    <div className="new-configuration-card">
                        {/*<div id="engine" className="row">
                            <div className="col-12">
                                <div className="label-tooltip">
                                    <label className="label">
                                        Engine Version
                                    </label>
                                </div>
                                <Components.SelectMenu
                                    noValueLabel="Choose a Version..."
                                    ref={this.versionSelect}
                                    items={this.props.gameEngines.map(
                                        gameEngine => ({
                                            label: gameEngine.version,
                                            value: gameEngine.id
                                        })
                                    )}
                                    value={
                                        this.props.creatingConf
                                            ? this.props.creatingConf.values
                                                  .engine
                                            : null
                                    }
                                    onChange={this.onVersionChange}
                                />
                            </div>
                                </div>*/}

                        {this.props.creatingConf && (
                            <div id="subsidiary" className="row">
                                <div className="col-6">
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Subsidiary
                                        </label>
                                    </div>
                                    <Components.SelectMenu
                                        ref={this.subsidiarySelect}
                                        items={
                                            this.props.subsidiaries &&
                                            this.props.subsidiaries.length > 0
                                                ? SubsidiaryUtils.subsidiarySelectItems(
                                                    this.props.subsidiaries
                                                )
                                                : []
                                        }
                                        noValueLabel="Choose Subsidiary..."
                                        value={
                                            this.props.creatingConf
                                                ? this.props.creatingConf.values
                                                    .subsidiary
                                                : null
                                        }
                                        onChange={this.onSubsidiaryChange}
                                    />
                                </div>
                                <div className="col-6">
                                    <Form
                                        key={`${this.props.creatingConf.values.id}`}
                                        ref={this.form}
                                        fields={labelFormFields}
                                        initialValues={
                                            this.props.creatingConf
                                                ? {
                                                    label:
                                                        this.props
                                                            .creatingConf
                                                            .values.label ||
                                                        ""
                                                }
                                                : {label: ""}
                                        }
                                        onChange={this.labelFormChange}
                                    />
                                </div>
                            </div>
                        )}

                        {this.props.creatingConf && this.renderSchemaForm()}

                        {this.state.txtErrorForm && (
                            <div className="row">
                                <div className="col-12 input-error-message">
                                    {this.state.txtErrorForm}
                                </div>
                            </div>
                        )}

                        {this.props.creationMode ==
                            CreationModes.ADD_CONFIGURATION && (
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            className="red-btn create-btn"
                                            disabled={
                                                !this.props.creatingConf ||
                                                !this.props.creatingConf.values.subsidiary ||
                                                !this.props.creatingConf.isValid
                                            }
                                            onClick={this.onCreate}
                                        >
                                            Create
                                        </button>
                                    </div>
                                </div>
                            )}

                        {this.props.creationMode ==
                            CreationModes.EDIT_CONFIGURATION && (
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            className="red-btn create-btn"
                                            onClick={this.onEdit}
                                            disabled={
                                                !this.props.creatingConf ||
                                                !this.props.creatingConf.isValid
                                            }
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: gamesStoreSelectors.creationMode(state),
    creatingConf: gamesStoreSelectors.creatingConf(state),
    gameEngines: gamesStoreSelectors.gameEngines(state),
    gameEnginesLoading: gamesStoreSelectors.gameEnginesLoading(state),
    enginesSchemas: gamesStoreSelectors.enginesSchemas(state),
    enginesSchemasLoading: gamesStoreSelectors.enginesSchemasLoading(state),
    subsidiaries: gamesStoreSelectors.subsidiaries(state),
    subsidiariesLoading: gamesStoreSelectors.subsidiariesLoading(state),
    denominations: gamesStoreSelectors.denominations(state),
    denominationsLoading: gamesStoreSelectors.denominationsLoading(state),
    gameInfo: gamesStoreSelectors.game(state)
});

const mapDispatchToProps = {
    updateCreatingConf: GamesActionCreators.updateCreatingConf
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateConfiguration);
